module.exports = __webpack_public_path__ + "media/images/support/geolocation/geolocation-firefox-permission-2c-1c782adb1235b2ad7471019816741cc9.png";